export default {
    billingPage: {
        postageReview: {
            title: 'Invoice Review', invoice: 'Invoice No.', carrier: 'Carrier', file: 'File Name',
            current: 'Current Charge Amt.', total: 'Customer Charge Total', aligned: 'Aligned', mismatch: 'Mismatch',
            no: 'No.', customerInvoice: 'Customer Invoice ID', client: 'Client Code', charged: 'Charged Price',
            notInvoiced: 'Not Invoiced', empty: 'No associated customer charges', sum: 'Total',
            export: 'Export CSV', refresh: 'Refresh', retry: 'Retry', close: 'Close',
            error: 'Unable to load invoice review. Please retry.'
        },
        Billing: 'Billing Management',
            BillingStatusPREVIEW: 'PREVIEW',
            BillingStatusPAID: 'PAID',
            BillingStatusPARTIAL: 'PARTIAL',
            BillingStatusUNPAID: 'UNPAID',
            BillingStatusOVERPAID: 'OVERPAID',
            BillingStatusDRAFT: 'Draft',
            BillingStatusRUNNING: 'Active',
            BillingStatusSTOP: 'Inactive',
            zoneGroup: 'Zone Group',
            Postcode: 'Postcode Count',
            Updated: 'Last Updated',
            PostcodeS: 'Start Postcode',
            PostcodeE: 'End Postcode',
            Download: 'Download',
            DisableDate: 'Disable date',
            searchName: 'Charge Item',
            searchID: 'Search by Invoice No.',
            searchIDs: 'Invoice No.',
            Status: 'Status',
            yearAndWeek: 'Date Selection',
            yearAndWeeks: 'Select YR/WK',
            ApplyWeek: 'Apply Week',
            InvoiceWeek: 'Invoice Week',
            yearAndData: 'Please select a piece of data for the generation operation, or select a date and customer for the generation operation',
            Customer: 'Please Select Customer',
            Customers: ' Please select at least one customer.',
            oney: 'Only one can be selected !',
            description: 'Description',
            tag: 'Tag',
            CreditType: 'Credit Amount Mode',
            creditType: 'Credit Type',
            Credit: 'Credit Amount (excl. GST)',
            CreditGST: 'Credit Amount (Incl. GST)',
            creditNoe: 'Create Credit Note',
            creditNote: 'Separated Credit Note',
        BillingPrice: 'Price Card',
            serviceType: 'Service Type',
            price: 'Unit Price',
        BillingServiceInvoices: 'Service Invoices',
            totalBalance: 'Total Balance',
            totalBalance1: 'Total Balance',
            totalAvailable1: 'Total Available',
            totalCredit1: 'Total Credit',
            totalUnpaid1: 'Total Unpaid',
            downloadInvoice: 'Invoice',
            downloadReport: 'Breakdown Report',
            invoiceNumber: 'Invoice No.',
            LogisticService: 'Logistic Service',
            TrackingNo: 'Tracking No.',
            Year: 'Year',
            Week: 'Week',
            YearWeek: 'Year/Week',
            Date: 'Invoice Date',
            invoicePrice: 'Total Amount',
            Paid: 'Paid Amount',
            Balance: 'Outstanding Balance',
        BillingCategories: 'Charge Item',
            create: '+ Create New',
            createTag: '+ New Tag',
            name: 'Name',
            code: 'Code',
            Version: 'Version',
            effectiveDate: 'Date signed',
            state: 'Status',
            group: 'Group',
            position: 'Position',
            blTip: 'The sum of the ratios must equal 100',
            department: 'Department',
            hourlyWage: 'HourlyWage',
            Logic: 'Logic',
            run: 'Run',
            stop: 'Stop',
            billingEdit: 'Billing Edit',
            billingAdd: 'Add Charge Item',
            billingView: 'Billing View',
            categoryType: 'Category Type',
            categoryCode: 'Category Code',
            categoryName: 'Charge Item',
            categoryEnName: 'Category EnName',
            quotationGroup: 'Quotation Group',
            SAPGroup: 'SAP Group',
            reportGroup: 'Report Group',
            Unit: 'Unit',
            sectionMin: 'Section Min',
            sectionMax: 'Section Max',
            standardPrice: 'Standard Price',
            standardCost: 'Standard Cost Minutes',
        BillingProfileTemplates: 'Client Template',
            template: 'Template',
            templateID: 'Template No.',
            profileTemplateName: 'Template Name',
            profileTemplateEnName: 'Profile Template EN Name',
            ChoseCategories: 'Select Charge Item',
            ChoseProfileTemplate: 'Chose Profile Template',
            lastUpdatedAt: 'Date Updated',
            lastUpdatedBY: 'Last Updated BY',
            usersCount: 'User QTY',
            OUTBOUND: 'OUTBOUND',
            STORAGE: 'STORAGE',
            Section: 'Range',
            Section1: 'Normal',
            Cost: 'Cost',
        BillingClientProfiles: 'Customer Profile',
            userAccount: 'User',
            companyName: 'Company Name',
            clientCode: 'Customer Code',
            index: 'No.',
            createdAt: 'Created By',
            updateProfile: 'Update Profile',
            createProfile: 'Create Profile Template',
            boundUser: 'Bound User:',
            billingProfileTemplate: 'Billing Profile Template:',
            chargeSection: 'Charge Section',
            pricing: 'Pricing',
            looseCartonPallet: 'Loose Carton/Pallet',
        BillingTransactions: 'Transactions',
            generateType: 'Charge Type',
            transactionNumber: 'Transaction No.',
            generate: 'Generate',
            quantity: 'Quantity',
            total: 'Total Pricing （excl. GST）',
            createTime: 'Date Created',
            transactionDetail: 'Transaction Detail',
            transactionForm: 'Transaction Info',
            orderID: 'Order ID',
            POID: 'PO ID',
            SKUID: 'SKU ID',
            comments: 'Notes',
            InternalNotes: 'Internal Notes',
            addInternalNotes: 'Add Internal Notes',
            messages: 'Messages',
            addmessages: 'Add Messages',
        BillingPreviewInvoices: 'Preview Invoice',
            companySeller: 'Customer',
            generateFeeRecords: 'Create Transaction',
            generateLastlnvoices: 'Generate Last lnvoices',
            generatePendingBilling: 'Generate Preview lnvoices',
            generateBilling: 'Create Invoice & Send Email',
            previewInvoicesNo: 'Preview Invoice No.',
            sellerCode: 'Customer Code',
            totalAmount: 'Total Amount',
            batchPDF: 'Batch Download PDF',
            batchBreakdown: 'Batch Download Breakdown',
            batchRemove: 'Remove Minimum Charge',
            generateContainerPreview: 'Generate Container Preview',
            generateContainerPreviewHint: 'Generate container service preview invoice for last week',
            MailProgress: 'Mail sending progress',
        BillingInvoices: 'Invoice',
            actions: 'Export',
            ExportPDF: 'Export PDF',
            ExportCSV: 'Export CSV',
            ExportPMTCSV: 'Export PMT CSV',
            UpdateInvoicePayment: 'Update Invoice Payment',
            PaidAmount: 'Paid Amount',
            InvoicesNo: 'Invoice No.',
            DateOfInvoices: 'Invoice Date',
            dueDate: 'Due Date',
            Period: 'Period',
        BillingAdditionalCharge: 'Manual Charge',
            userName: 'Username / Customer Code',
            ChargeItem: 'Charge Item',
            Count: 'Count',
            Counts: 'Count',
            ManualHistory: 'Transaction History',
            TotalPrice: 'TotalPrice',
            YearWeek: 'Year / Week',
            Pricing: 'Pricing',
            CreateDate: 'Date Created',
            gmtCreate: 'Transaction Time',
            Coments: 'Notes',
            Submitter: 'Created By',
            Action: 'Action',
            Client: 'Customer',
            Category: 'Charge Item',
            PurchaseOrder: 'Receipt Order',
            OrderNumber: 'Order No.',
            ReturnOrder: 'Return Order',
            sure: 'Are you sure to save the data?',
            normal: 'Add Normal Fee',
            once: 'Add Disposable Fee',
            oror: 'or',
        BillingRegularSurcharge: 'Regular Surcharge',
            BasedSource: 'Service Type',
            ChargeValue: 'Charge Value',
            CoverageRate: 'Coverage Rate (%)',
            RegularRules: 'Regular Surcharge Rules',
            billCategoryCode: 'Charge Item',
            chargeRate: 'chargeRate',
            startDate: 'Start Date',
            endDate: 'End Date',
            EditSurcharge: 'Edit Regular Surcharge',
            ACTIVE: 'ACTIVE',
            UNACTIVE: 'UNACTIVE',
        BillingInvoiceStatement: 'Invoice Statement',
            CustomerName: 'Customer Name',
            bpCode: 'BP Code',
            Floating: 'Margin',
            ratePrice: 'Floating Freight',
            costPrice: 'Shipping Cost',
            send: 'Send Email',
            Current: 'Total Current Amount',
            In30Day: 'Total 30 Days Amount',
            Over30Day: 'Total Over 30 Days Amount',
            Balances: 'Balance',
            Email: 'Billing Email',
            Deposit: 'Deposit',
            Currents: 'Current',
            In30Days: '30 Days',
            Over30Days: 'Over 30 Days',
        BillingShippingCharges: 'Shipping Comparison',
            CAMPARE: 'SHIPPING CAMPARE',
            DBFILE: 'DB SAVED FILE HISTORY',
            HISTORY: 'SURCHARGED FILE HISTORY',
            ImportCSV: 'Import CSV File:',
            ClickImport: 'Click to Import',
            Carrier: 'Carrier Company:',
            InvoiceDate: 'Invoice Date:',
            Choose: 'Choose Date',
            COMPARE: 'COMPARE',
            ImportDB: 'IMPORT TO DB',
            RecordQty: 'Record Qty:',
            Rating: 'Total Rating Price:',
            Actual: 'Total Actual Price:',
            Diff: 'Total Diff Price:',
            TotalDiff: 'Total Diff%:',
            UnMatched: 'Un-matched-Items:',
            Reference: 'Reference ID',
            ActualPrice: 'Actual Price',
            MatchedItems: 'Matched Items:',
            Internal: 'Order Internal ID',
            Consignment: 'Consignment ID',
            RatingPrice: 'Rating Price Ex.gst(With Margin)',
            Difference: 'Difference',
            DifferencePercent: 'Difference Percent',
            Surcharge: 'Surcharge Transactions:',
            CHARGE: 'CHARGE',
            SurchargeAmount: 'Surcharge Amount',
            SurchargeDetail: 'Surcharge Detail',
            SurchargeName: 'Surcharge Name',
            IsCharged: 'Is Charged?',
            FileName: 'File Name',
            OperatedDate: 'Operated Date',
            Operator: 'Operator',
            ChargedOrders: 'Charged Orders',
            Carrie: 'Carrier',
            SurchargedItems: 'SurchargedItems',
            SurchargedAmount: 'SurchargedAmount',
        PostageRecharge: 'Postage Charges',
            PostageRechargeDetail: 'Postage Charges Detail',
            PostageRechargeCarrier: 'Logistics Company',
            PostageRechargeAllPartners: 'All Partners',
            PostageRechargeInvoiceNo: 'Invoice No.',
            PostageRechargeSearchInvoice: 'Search invoice',
            PostageRechargeNewInvoice: 'New Invoice',
            PostageRechargeTotalInvoiceAmt: 'Total Invoice Price',
            PostageRechargeTotalInvoiceDesc: 'Invoice total in current filter',
            PostageRechargeTotalRatePrice: 'Total API Price',
            PostageRechargeTotalRateDesc: 'Rated price in current filter',
            PostageRechargeTotalUnmatched: 'Unmatched Price',
            PostageRechargeTotalUnmatchedDesc: 'Amount requiring attention',
            PostageRechargePendingUploads: 'Pending Uploads',
            PostageRechargePendingDesc: 'Companies missing invoices',
            PostageRechargeInvoiceAmt: 'Invoice Amount',
            PostageRechargeCollected: 'Total Charged Price',
            PostageRechargeRatePrice: 'API Amount',
            PostageRechargeDifference: 'Difference',
            PostageRechargeUnmatchedPrice: 'Unmatched Amount',
            PostageRechargeAuditDetail: 'Audit Detail',
            PostageRechargeUnmatchedAmount: 'Unmatched Amount',
            PostageRechargeUnmatchedReason: 'Reason for Unmatched Amount',
            PostageRechargeReasonPlaceholder: 'Provide justification for discrepancies',
            PostageRechargeSaveReason: 'Save Reason',
            PostageRechargeMatchedOrders: 'Matched Orders',
            PostageRechargeUnmatchedItems: 'Unmatched Items',
            PostageRechargeOrderNumber: 'Order Number',
            PostageRechargeInvoicePrice: 'Invoice Amount',
            PostageRechargeTotalChargedPrice: 'Total Charged Price',
            PostageRechargeTotalInvoicePrice: 'Total Invoice Price',
            PostageRechargeRate: 'Rate',
            PostageRechargeRawData: 'Original CSV Raw Data',
            PostageRechargeManualMatch: 'Manual Match',
            PostageRechargeInvoiceRequired: 'Invoice number is required.',
            PostageRechargeReasonIdRequired: 'Invoice id is required to save the reason.',
            PostageRechargeUploadTitle: 'Upload New Invoice',
            PostageRechargeCarrierOptionsError: 'Unable to load carriers. Click Upload to retry.',
            PostageRechargeInvoicePlaceholder: 'e.g. INV-2024-001',
            PostageRechargeIssueDate: 'Issue Date',
            PostageRechargeSelectIssueDate: 'Select Issue Date',
            PostageRechargeSelectPartner: 'Select Partner',
            PostageRechargeFinancialAmount: 'Financial Amount',
            PostageRechargeFinancialAmountPlaceholder: 'Enter Financial Amount',
            PostageRechargeUploadFile: 'Invoice File',
            PostageRechargeUploadPdfFile: 'Invoice PDF File',
            PostageRechargeUploadCsvFile: 'Invoice CSV File',
            PostageRechargeUploadCsvXlsxFile: 'Invoice CSV / XLSX File',
            PostageRechargeDropFile: 'Drop file here, or click to upload',
            PostageRechargeUploadTip: 'PDF, CSV, XLS or XLSX up to 50MB',
            PostageRechargeUploadPdfTip: 'PDF only, up to 50MB',
            PostageRechargeUploadCsvTip: 'CSV only, up to 50MB',
            PostageRechargeUploadCsvXlsxTip: 'CSV or XLSX, up to 50MB',
            PostageRechargeUpload: 'Upload',
            PostageRechargeUploadFileTypeTip: 'Only PDF, CSV, XLS and XLSX files are supported.',
            PostageRechargeUploadPdfFileTypeTip: 'Only PDF files are supported.',
            PostageRechargeUploadCsvFileTypeTip: 'Only CSV files are supported.',
            PostageRechargeUploadCsvXlsxFileTypeTip: 'Only CSV or XLSX files are supported.',
            PostageRechargeUploadSizeTip: 'File size cannot exceed 50MB.',
            PostageRechargeUploadFileRequired: 'Please upload an invoice file.',
            PostageRechargeUploadPdfFileRequired: 'Please upload the invoice PDF file.',
            PostageRechargeUploadCsvFileRequired: 'Please upload the invoice CSV file.',
            PostageRechargeUploadCsvXlsxFileRequired: 'Please upload the invoice CSV or XLSX file.',
            PostageRechargeWeekRequired: 'Please select invoice week.',
            PostageRechargeManualMatchTitle: 'Manual Item Reconciliation',
            PostageRechargeTargetItem: 'Target Unmatched Item',
            PostageRechargeSearchOrder: 'Search for Order',
            PostageRechargeSearchOrderPlaceholder: 'Enter order number or tracking number',
            PostageRechargeCurrentSelection: 'Current Selection',
            PostageRechargeConfirmMatch: 'Confirm Match',
            PostageRechargeSearchOrderRequired: 'Please enter a search keyword.',
            PostageRechargeMatchRequired: 'Please select a logistics record.',
            PostageRechargeInvoiceAmount: 'Invoice Amount',
            PostageRechargeOrderInvoiceAmount: 'Invoice Amount',
            PostageRechargeMatchedAmount: 'Matched Amount',
            PostageRechargeCostReceived: 'Cost Received',
            PostageRechargeAmountReceived: 'Amount Received',
            PostageRechargeCurrentChargeAmount: 'Current Charge Amount',
            PostageRechargeAverageProfitMargin: 'Average Profit Margin',
            PostageRechargeListInvoiceNo: 'Invoice No.',
            PostageRechargeListYearWeek: 'Year /\nWeek',
            PostageRechargeListCarrier: 'Carrier',
            PostageRechargeListInvoiceAmount: 'Invoice\nAmt.',
            PostageRechargeListMatchedAmount: 'Matched\nAmt.',
            PostageRechargeListUnmatchedAmount: 'Unmatched\nAmt.',
            PostageRechargeListCostReceived: 'Cost\nReceived',
            PostageRechargeListAmountReceived: 'Amt.\nReceived',
            PostageRechargeListCurrentChargeAmount: 'Current Charge\nAmt.',
            PostageRechargeListAverageProfitMargin: 'Avg. Profit\nMargin',
            PostageRechargeListCreatedTime: 'Created\nTime',
            PostageRechargeOrderCostReceived: 'Order Cost Received',
            PostageRechargeOrderAmountReceived: 'Order Amount Received',
            PostageRechargeTotalOrderCost: 'Total Order Cost',
            PostageRechargeCurrentDifference: 'Current Difference',
            PostageRechargeProfitMargin: 'Profit Margin',
            PostageRechargeTrackingNumber: 'Tracking Number',
            PostageRechargeInvoiceOverview: 'Invoice Overview',
            PostageRechargeMatchedOrder: 'Matched Order',
            PostageRechargeInvoiceSummaryDesc: 'Invoice total in current filter',
            PostageRechargeMatchedSummaryDesc: 'Amount successfully matched to orders',
            PostageRechargeUnmatchedSummaryDesc: 'Amount requiring matching',
            PostageRechargeChargeSummaryDesc: 'Amount to charge in current filter',
            PostageRechargeMarginSummaryDesc: 'Average margin across matched orders',
            PostageRechargeCalculationBreakdown: 'Calculation Breakdown',
            PostageRechargeCalculatedFromOrders: 'Calculated from matched order details.',
            PostageRechargeViewOrderBreakdown: 'View Order Breakdown',
            PostageRechargeValidationFailed: 'Validation Failed',
            PostageRechargeExpected: 'Expected',
            PostageRechargeActual: 'Actual',
            PostageRechargeInvoiceValidationMessage: 'Invoice amount does not equal matched amount plus unmatched amount.',
            PostageRechargeInvoiceFormulaDesc: 'Breakdown of the original logistics invoice amount.',
            PostageRechargeInvoiceFormula: 'Invoice Amount = Matched Amount + Unmatched Amount',
            PostageRechargeDifferenceFormulaDesc: 'Matched cost that has not yet been processed for charging.',
            PostageRechargeDifferenceFormula: 'Difference = Matched Amount - Cost Received',
            PostageRechargeCurrentDifferenceFormulaDesc: 'New order cost not yet included in previous charging.',
            PostageRechargeCurrentDifferenceFormula: 'Current Difference = Total Order Cost - Order Cost Received',
            PostageRechargeCurrentChargeFormulaDesc: 'Amount to charge for the current cost difference.',
            PostageRechargeCurrentChargeFormula: 'Current Charge Amount = Current Difference / (1 - Profit Margin)',
            PostageRechargeListChargeFormulaDesc: 'Total amount to charge across matched order details.',
            PostageRechargeListChargeFormula: 'Current Charge Amount = Sum of Current Charge Amount across matched orders',
            PostageRechargeProfitMarginFormulaDesc: 'Profit margin after the current charge is applied.',
            PostageRechargeProfitMarginFormula: 'Profit Margin = (Current Charge Amount - Current Difference) / Current Charge Amount',
            PostageRechargeAverageMarginFormulaDesc: 'Weighted average profit margin across matched orders.',
            PostageRechargeAverageMarginFormula: 'Average Profit Margin = Weighted margin across matched order details',
        BillingStorageReport: 'Storage Report',
        BillingInvoiceReport: 'Invoice Report',
            // 1 total
            IRclientType: 'Client Type',
            IRActive: 'Active Client QTY',
            IRPallet: 'Pallet Qty',
            IROrder: 'Order Qty',
            IRPO: 'PO Qty',
            IRReturn: 'Return Qty',
            IRCMB: 'CBM Qty',
            IRTI: 'Total Income',
            IRTC: 'Total Cost',
            IRTGP: 'Total Gross Profit',
            IRTPM: 'Total Profit Margin',
            IRWTI: 'Weekly Total Income',
            IRWTC: 'Weekly Total Cost',
            IRWTGP: 'Weekly Total Gross Profit',
            IRWTPM: 'Weekly Total Profit Margin',
            // 2 pallet
            IRTIP: 'Total Income / Pallet',
            IRTCP: 'Total Cost / Pallet',
            IRTGPP: 'Total Gross Profit / Pallet',
            IRTPMP: 'Total Profit Margin / Pallet',
            IRWTIP: 'Weekly Total Income / Pallet',
            IRWTCP: 'Weekly Total Cost / Pallet',
            IRWTGPP: 'Weekly Total Gross Profit / Pallet',
            IRWTPMP: 'Weekly Total Profit Margin / Pallet',
            // 3 CBM
            IRTIM: 'Total Income / CBM',
            IRTCM: 'Total Cost / CBM',
            IRTGPM: 'Total Gross Profit / CBM',
            IRTPMM: 'Total Profit Margin / CBM',
            IRWTIM: 'Weekly Total Income / CBM',
            IRWTCM: 'Weekly Total Cost / CBM',
            IRWTGPM: 'Weekly Total Gross Profit / CBM',
            IRWTPMM: 'Weekly Total Profit Margin / CBM',
            // 4 clientqty
            IRNew: 'New Client Qty',
            IRLeave: 'Leave Client Qty',
            IRWTAC: 'Weekly Total Active Client',
            IRWTNC: 'Weekly Total New Client',
            IRWTLC: 'Weekly Total Leave Client',
            // 5 client
            IRClientCode: 'Client Code',
            IRtype: 'Type',
            CBM: 'CBM',
            Postage: 'Postage',
            Income: 'Income',
            GrossProfit: 'Gross Profit',
            ProfitMargin: 'Profit Margin',
            // 6 postage
            Courier: 'Courier',
            // 7 sales
            Sales: 'Sales',
            Company: 'Company',
        // BusinessBillingOperationLog
            Menu: 'Menu',
            Operator2: 'Operator',
            Method: 'Method',
            Content: 'Content',
            OperateTime: 'Operate Time',

        // BillingDeliveryNote
        OrderInfo: 'Order Info',
        OrderIdTip: 'Please select an order',
        SellerCode: 'Please enter the seller code',
        PalletQty: 'Pallet Qty',
        TotalPalletQty: 'Total Pallet Qty',
        WoodenStandardQty: 'Standard Pallet Qty',
        ChepPalletQty: 'Chep Pallet Qty',
        LoscamPalletQty: 'Loscam Pallet Qty',
        CSGPalletQty: 'CSG Pallet Qty',
        ShrinkWrapQty: 'Shrink Wrap Qty',
        liftOnQty: 'Lift On Qty',
        strapWrapQty: 'Strapping Wrap Qty',
        LabourTime: 'Labour Time',
        Comments: 'Comments',
        instruction: 'Instruction',
        palletHeight: 'Pallet Height',
        printLabel: 'Label Print',
        PlaceOrder: 'Save',
        PlaceOrderTips: 'This logistics provider has been disabled by the customer. Confirm to proceed with booking?',
        DOWNLOADDELIVERYNOTE: 'Download Delivery Note',
        minText: 'min',
        NeedEqual: 'Need equal',
        PleaseSaveFirst: 'Please save first',
        theSameOrDerTip: 'The selected orders are not under the same customer.',
        // 运费比较
        consignmentNum: 'Tracking Number',
        ratedPrice: 'Rated Price',
        Carrierinvoicetotalprice: 'Invoice Total Price',
        difference: 'Difference',
        TotalsurchargedPrice: 'Total Surcharged Price',
        needChargePrice: 'Need Charge Price',
        ifNeedCharge: 'If Need Charge',
        MarginRate: 'Margin Rate',
        CBM:"CBM",
        customerPallet:"WMS Pallet",
        Palletchange: 'Pallet Change',
        PalletchangeIN: 'Pallet In',
        PalletchangeOUT: 'Pallet Out',
        errTip: 'The input value cannot exceed the existing value',
        tierName: 'Tier Name',
        salesTurnoverFrom: 'Sales Turnover',
        CurrentTier: 'Quotation Tier',
        EvaluatedTier: 'Actual Tier',
        CustomerTier: 'Customer Tier',
        // 历史成本
        historicalType: 'Template Type',
        historicalBB: 'To B Cost',
        historicalCC: 'To C Cost',
        historicalHis: 'History',
        hisGeneral: 'General Cost',
        hisTime: 'Time Cost',
        hisPerce: 'Time Percentage',
        // 开支管理
        expenseDate:'Expense Date',
        expenseLabour:'Office Labour',
        expenseExpense:'Other Expense',
        expenseWareh:'Rental Cost',
        expenseManage:'Expense Management',
        expenseStart:'Start Date Range',
        expenseEnd:'End Date Range',
        OrderPostagetime: 'Invoice Generation Time',
        OrderPostagecreate: 'Creation Time',
        OrderPostageImportPDF: 'Import PDF File',
        Amount: 'Invoice Amount',
        erpAmount: 'ERP Amount',
        totalDifference: 'Total Difference',
        customer: 'Customer',
        timePay: 'Charged By Time',
        quantityPay: 'Charged By Quantity',
        // 钱包
        DEPID:'Payment ID',
        DEPAmount:'Amount',
        DEPTime:'Transaction Time',
        DEPDetail:'Account Details',
        DEPReference:'Reference',
        DEPTrans:'Transaction Number',
        DEPraw:'RawInfo',
        DEPDes:'Description',
        DEPDeposit:'Prepay',
        DEPsub:'Submit',
        DEPAppro:'Approve',
        DEPTop:'Top-up',
        DEPInfo:'Payment Information',
        DEPFrom:'From',
        DEPTo:'To',
        DEPScre:'Screenshot',
        DEPRemark:'Remark',
        MyDepositPage: {
            title: 'Account Detail',
            Prepay: 'Prepay',
            Balance: 'Balance',
            Available: 'Available',
            Credit: 'Credit',
            Unpaid: 'Unpaid',
            SecurityBond: 'Security Bond',
            tip1: 'Kind reminder :  Fee details may be slightly delayed and are subject to the final invoice.',
            tip2: 'CSG reserves the right of final interpretation.',
            tips1: 'Balance',
            tips2: 'Available',
            tips3: 'Credit',
            tips4: 'Unpaid',
            tips5: 'Security Bond',
        },
        source:'Source',
        CApage:'Client Accounts',
        CAemail:'Email',
        CAaccount:'Account Balance',
        CAaccountF:'Account Balance(From)',
        CAaccountT:'Account Balance(To)',
        CATime:'Update Time',
        BillingCustomerInventoryPricing:'Inventory Value',
            InvnetoryValue:'Inventory Value',
            UnpaidInvoiceAmount:'Unpaid Invoice Amount',
            DefaultPrice:'Default Price',
            InventoryPrice:'Inventory Price',
            UnpaidInvoice:'Unpaid Invoice',
            Healthy:'Healthy',
            Risky:'Risky',
        BusinessBillingCostExpenditureStatistics:'Expense Management',
            expenseItem:'Cost Item',
            expenseCategory:'Expense Category',
            expensePeriod:'Expense Period',
        BillingCostItem:'Cost Item',
        zoneGroupType: 'Zone Group Type',
            zoneGroupType1: 'Ordinary Zone',
            zoneGroupType2: 'Remote Zone',
            zoneGroupType3: 'Rate Zone',
            zoneType: 'Zone Type',
            zone: 'Zone',
            zoneState: 'zone State',
            zoneCity: 'City',
            zonePostCode: 'Post Code',
            zoneCountry: 'Country',
    }
};
